export enum ErrorCode {
  FOREIGN_JOBSITES = 4507,
  TIME_OUT = 502,
  INTERNAL_SERVER_ERROR = 500,
}
